<template>
   <div class='combined-graph-wrapper'>
      <div class="form">
         <input-field
            label="Select Ratio"
            type="select"
            v-model="selectedEnergy"
            :options="energyOptions"
            :errors="[]"
         />
         <input-field
            label="Select Year"
            type="select"
            v-model="selectedYear"
            :options="yearOptions"
            :errors="[]"
         />
      </div>
      <div class="chart-wrapper">
         <chart :chart-data="chartOptions"/>
      </div>
   </div>
</template>

<script>
import Chart from '../../../../organisms/Home/Chart';
import InputField from '../../../../molecules/Login/InputField';
import { mapGetters } from 'vuex';

const tooltip = { 
   formatter: function ()
   {
      return this.points.reduce( (acc, point) =>
         {
            return `${acc}<br/>
               <span style="font-size: 1.4em; color:${point.series.color};">•</span>
               ${point.series.name}: <b>${point.y}</b>`;
         }, `${this.x} Km`);
   },
};

export default {
   name: 'ratio-graphs',
   components: {
      Chart,
      InputField,
   },
   computed: {
      ...mapGetters(["getBatResults"]),
      energyOptions()
      {
         if (this.getBatResults)
         {
            const options = [
               {title: "SHS/Grid",value: "shs"},
               {title: "SMG/Grid",value: "solar_minigrid"},
            ];
            if (!this.getBatResults.is_in_terai)
            {
               options.push({title: "MHP/Grid",value: "mhp"})
            }
            return options;
         }
         return [];
      },
      selectedRatio()
      {
         return this.energyOptions.find(item => item.value===this.selectedEnergy).title;
      },
      chartTitle()
      {
         return { text: `Cost Analysis: ${this.selectedRatio} for Year ${this.selectedYear}`, y: 18, margin: 15 };
      },
      chartOptions()
      {
         const results = this.getBatResults;
         console.assert(results, "no results");
         const series = [
            { name: this.selectedRatio, data: [], type: 'spline', zIndex: 1 },
            { name: 'Break through',  data:[], dataLabels: {format: ""}, type: 'spline' },
         ];
         const xAxis = {
            categories: [],
            title: {text: 'Distance'},
            labels: { format: "{value} Km" },
            crosshair: true,
         };
         if (results)
         {
            const formatRatio = num => parseFloat(num.toFixed(3));
            const {distances, life_cycle_costs} = results.energy_costs.year_wise_grid[this.selectedYear];
            const lccOfSelectedEnergyAtSelectedYear = results.energy_costs[this.selectedEnergy].cost_series.life_cycle_costs[this.selectedYear];
            const ratioData = life_cycle_costs.map( lcc => formatRatio(lccOfSelectedEnergyAtSelectedYear/lcc) );
            xAxis.categories = [...distances];
            series[0].data = [...ratioData];
            series[1].data = ratioData.map(() => 1);
         }
         return {
            title: this.chartTitle,
            tooltip,
            xAxis,
            plotOptions: {
               series: { dataLabels: {enabled: true} },
            },
            yAxis: { title: { text: this.selectedRatio } },
            series,
         };
      },
   },
   data() {
      return {
         selectedEnergy: "shs",
         selectedYear: 0,
         yearOptions: Array.from( Array(15), (_,index) => ({title: `Year ${index}`, value: index}) ),
      };
   },
}
</script>

<style lang="scss" scoped>
.combined-graph-wrapper {
   height: 30em;
   display: flex;
   flex-direction: column;

   > .chart-wrapper {
      flex: 1;
   }
   > .form {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1em;
   }
}
</style>
